<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-12 text-left">
        <div class="form-group" v-if="brandBrief.length > 2 && $route.name !== 'storeInfo'">
          <!-- <select class="form-control h-38" v-model="brand_query">
            <option :value="0" v-if="roleType !== 10">== 品牌 ==</option>
            <option v-for="brand in brandBrief" :value="brand.value">
              {{brand.label}}
            </option>
          </select> -->
          <multiselect
            v-model="brand_query"
            :options="brandBrief"
            :searchable="true"
            :allow-empty="false"
            :close-on-select="true"
            placeholder="== 品牌 =="
            :show-labels="false"
            :multiple="false"
            label="label"
            track-by="value"
          >
          </multiselect>
        </div>
        <div class="form-group" v-if="brand_query.value !== 0 && brand_query.value !== '0' && storeBriefQ.length > 2 && $route.name !== 'storeInfo'">
          <!-- <select class="form-control h-38" v-model="store_query">
            <option :value="0">== 門市 ==</option>
            <option v-for="store in storeBriefQ" :value="store.value">
              {{store.label}}
            </option>
          </select> -->
          <multiselect
          v-model="store_query"
          :options="storeBriefQ"
          :searchable="true"
          :allow-empty="false"
          :close-on-select="true"
          placeholder="== 門市 =="
          :show-labels="false"
          :multiple="false"
          label="label"
          track-by="value"
          >
          </multiselect>
        </div>
        <span style="float: right; font-size: 12px; color: red;">*項目名稱：最多可輸入10個字 <br> *追蹤碼：限25字內，僅限英數大小寫，不可符號</span>
        <br>
          <div class="input-group" >
            <span class="input-group-addon">
              項目名稱
            </span>
            <input v-model="name_query" class="form-control" placeholder="" type="text" maxlength="10">
          </div>
          <div class="input-group" >
            <span class="input-group-addon">
              追蹤碼
            </span>
            <input v-model="code_query" class="form-control" placeholder="僅大小寫英文和數字" type="text" maxlength="25">
          </div>
          <div class="input-group" >
            <span class="input-group-addon">
              入口
            </span>
          <select class="form-control h-38" v-model="sourceSelect">
            <option v-for="source in sourceList" :value="source.value">
              {{source.label}}
            </option>
          </select>
          </div>
         <button type="button" class="btn btn-danger" @click="click_add">+新增</button>

        <br>
      </div>
    </div>     
      <br>
      <div class="alert alert-info-bg">
        <ul>
          <li>你訂團隊持續在進行系統優化，如有追蹤訂單來源需求，可自【新後台管理系統】-【成效數據中心】使用[自訂報表]下載報表分析。</li>
          <li>此追蹤碼功能於近期將不再進行相關維護，如需更進階數據分析需求，可洽你訂同仁詢問GA4數據分析，會有專人與您詳細說明完整方案。</li>
        </ul>
      </div>
      <hr>   
      <br>
    <div class="form-group" v-if="brandBrief.length > 2 && $route.name !== 'storeInfo'">
        <!-- <select class="form-control h-38" v-model="brandSelect">
          <option :value="0" v-if="roleType !== 10">== 品牌 ==</option>
          <option v-for="brand in brandBrief" :value="brand.value">
            {{brand.label}}
          </option>
        </select> -->
        <multiselect
          v-model="brandSelect"
          :options="brandBrief"
          :searchable="true"
          :allow-empty="false"
          :close-on-select="true"
          placeholder="== 品牌 =="
          :show-labels="false"
          :multiple="false"
          label="label"
          track-by="value"
        >
        </multiselect>
      </div>
      <div class="form-group" v-if="storeBrief.length > 2 && $route.name !== 'storeInfo'">
        <!-- <select class="form-control h-38" v-model="storeSelect">
          <option :value="0">== 門市 ==</option>
          <option v-for="store in storeBrief" :value="store.value">
            {{store.label}}
          </option>
        </select> -->
        <multiselect
          v-model="storeSelect"
          :options="storeBrief"
          :searchable="true"
          :allow-empty="false"
          :close-on-select="true"
          placeholder="== 門市 =="
          :show-labels="false"
          :multiple="false"
          label="label"
          track-by="value"
        >
        </multiselect>
      </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">日期</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">項目名稱</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">追蹤碼</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">入口</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">網址</th>
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <tbody v-else-if="orderList.length === 0">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="orderList.length > 0">
          <tr class="even" role="row" v-for="(order, index) in orderList" :class="{'bg-pre-order': order.order_method === 2}">
            <td class="sorting_1">{{getTime(order.create_time)}}</td>
            <td>{{order.name}}
            </td>
            <td>{{order.code}}</td>
            <td>{{sourceTypeName(order.url_type)}}</td>
            <td class="row"><div class="col-6">{{order.url}}</div>
              <br>
              <div class="col-6">
                <button type="button" class="btn btn-primary" v-clipboard:copy="order.url" v-clipboard:success="copySuccess">複製</button>
                <button type="button" class="btn btn-danger" @click="delcode(order.id, order.target_brand_id, order.target_store_id)">刪除</button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
      >
      </paginate>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import $ from 'jquery'
// clipboard
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

export default{
  name: 'QueryStringTemp',
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: '',
      total: 1,
      count: 20,
      orderList: [],
      shopperId: 0,
      shopper: '',
      orderSn: '',
      subOrderAmount: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      // QueryString
      brandSelect: {
        value: 0,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 0,
        label: '== 門市 =='
      },
      brand_query: {
        value: 0,
        label: '== 品牌 =='
      },
      store_query: {
        value: 0,
        label: '== 門市 =='
      },
      name_query: null,
      code_query: null,
      sourceSelect: 999,
      // QueryString
      typeSelect: 99,
      statusSelect: 999,
      deTypeSelect: 999,
      trTypeSelect: 999,
      isCreatedTime: false,
      isCreatedStore: false,
      // QueryString
      isCreatedStoreQ: false,
      // date
      menuTime: {
        start: {
          time: moment().format('YYYY-MM-DD')
        },
        end: {
          time: moment().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      brandBrief: [],
      storeBrief: [],
      storeBriefQ: [],
      // QueryString
      brandDefault: 0,
      sourceList: [
        {label: '== 來源 ==', value: 999},
        {label: '品牌入口', value: 4},
        {label: '門市入口', value: 5},
        {label: '菜單入口', value: 3}
      ],
      isLoading: true
    }
  },
  methods: {
    statePosition () {
      var roleType = parseInt(this.getRoleType, 10)
      if (roleType === 99) {  // platform
        return 'platform'
      } else if (roleType === 30) { // brand
        return 'brand'
      } else if (roleType === 10) { // store
        return 'store'
      }
    },
    click_add () {
      const self = this
      var state = self.statePosition()
      console.log(self.storeBriefQ.length)
      if (state === 'platform') {
        if (self.brand_query.value === 0) {
          this.$notify({
            title: '請選擇品牌',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (!self.name_query) {
          this.$notify({
            title: '請填寫項目名稱',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (!self.code_query) {
          this.$notify({
            title: '請填寫追蹤碼',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (self.sourceSelect === 999) {
          this.$notify({
            title: '請選擇入口',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else {
          if (self.sourceSelect === 3 || self.sourceSelect === 5) {
            if (self.storeBriefQ.length === 0) {
              this.$notify({
                title: '此店家無門市',
                duration: 3000,
                type: 'danger',
                width: 400
              })
            } else if (self.store_query.value === 0) {
              this.$notify({
                title: '尚未選擇店家',
                duration: 3000,
                type: 'danger',
                width: 400
              })
            } else {
              self.postVendorCode()
            }
          } else {
            self.postVendorCode()
          }
        }

        // else if(state==='brand')
        // else if(state==='store')
      } else if (state === 'brand') {
        if (!self.name_query) {
          this.$notify({
            title: '請填寫項目名稱',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (!self.code_query) {
          this.$notify({
            title: '請填寫追蹤碼',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (self.sourceSelect === 999) {
          this.$notify({
            title: '請選擇入口',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else {
          if (self.sourceSelect === 3 || self.sourceSelect === 5) {
            if (self.storeBriefQ.length === 0) {
              this.$notify({
                title: '此店家無門市',
                duration: 3000,
                type: 'danger',
                width: 400
              })
            } else if (self.store_query.value === 0) {
              this.$notify({
                title: '尚未選擇店家',
                duration: 3000,
                type: 'danger',
                width: 400
              })
            } else {
              self.postVendorCode()
            }
          } else {
            self.postVendorCode()
          }
        }
      } else if (state === 'store') {
        if (!self.name_query) {
          this.$notify({
            title: '請填寫項目名稱',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (!self.code_query) {
          this.$notify({
            title: '請填寫追蹤碼',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (self.sourceSelect === 999) {
          this.$notify({
            title: '請選擇入口',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else {
          if (self.sourceSelect === 5 || self.sourceSelect === 1 && self.store_query.value !== 0) {
            self.postVendorCode()
          } else {
            this.$notify({
              title: '請選擇門市入口',
              duration: 3000,
              type: 'danger',
              width: 400
            })
          }
        }
        // else if(state==='brand')
        // else if(state==='store')
      }
    },
    copySuccess () {
      this.$notify('已複製連結')
      // this.$notify({
      //   title: '成功複製連結',
      //   duration: 3000,
      //   type: 'danger',
      //   width: 400
      // })
    },
    sourceTypeName (type) {
      if (type === 1) {
        return '菜單入口'
      } else if (type === 2) {
        return '品牌入口'
      } else if (type === 3) {
        return '菜單入口'
      } else if (type === 4) {
        return '品牌入口'
      } else if (type === 5) {
        return '門市入口'
      }
    },
    isActive (index) {
      if (Number(this.tableIndex) === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getOrderList()
    },
    getOrderList (page) {
      this.isLoading = true
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var self = this
      var roleType = parseInt(this.getRoleType, 10)
      var url
      const data = {
        page: this.tableIndex,
        count: this.count,
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper,
        sub_order_amount: this.subOrderAmount
      }
      if (roleType === 99) {  // platform
        url = '/vendor/srcVendorCode/list?page=' + data.page + '&size=' + data.count
      } else if (roleType === 30) { // brand
        url = '/brand/' + self.brandSelect.value + '/srcVendorCode/list?page=' + data.page + '&size=' + data.count
      } else if (roleType === 10) { // store
        url = '/store/' + self.storeSelect.value + '/srcVendorCode/list?page=' + data.page + '&size=' + data.count
      }
      if (parseInt(this.searchSelect, 10) === 1) {
        // use time search
        url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        // use order sn search
        url = url + '&order_sn=' + data.order_sn
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        // use order sn search
        url = url + '&shopper_name=' + data.shopper_name
      } else if (parseInt(this.searchSelect, 10) === 4 && data.sub_order_amount) {
        // use sub order amount search
        url = url + '&sub_order_amount=' + data.sub_order_amount
      }
      if (this.shopperId && this.$route.name === 'memberOrderTable') url = url + '&shopper_id=' + this.shopperId
      if (this.brandSelect.value !== '0' && this.brandSelect.value !== 0 && url) url = url + '&brand_id=' + this.brandSelect.value
      if (this.storeSelect.value !== '0' && this.storeSelect.value !== 0 && url) url = url + '&store_id=' + this.storeSelect.value
      // if (this.typeSelect !== '99' && this.typeSelect !== 99 && url) url = url + '&order_type=' + this.typeSelect
      // if (this.statusSelect !== '999' && this.statusSelect !== 999 && url) url = url + '&status=' + this.statusSelect
      // if (this.deTypeSelect !== '999' && this.deTypeSelect !== 999 && url) url = url + '&delivery_type=' + this.deTypeSelect
      // if (parseInt(this.trTypeSelect, 10) !== 999 && url) url = url + '&trade_type=' + this.trTypeSelect
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.orderList = response.data.list
            console.log(self.orderList)
            self.total = response.data.total
            if (self.orderList.length) $('.odd').css('display', 'none')
            self.isLoading = false
          }
        })
      }
    },
    getBrandBrief () {
      let self = this
      let url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      self.brandBrief = [{ value: 0, label: '== 品牌 ==' }]
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (i === 0 && self.roleType === 10) {
              self.brandSelect = obj
              self.brand_query = obj
            } else if (i === 0 && bList.length === 1) {
              self.brandSelect = obj
              self.brand_query = obj
            }
          }
          if (self.roleType === 30 || self.roleType === 99) self.getOrderList()
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | QueryStringTemp')
      this.storeBrief = [{value: 0, label: '==門市=='}]
      var self = this
      var storeS = window.sessionStorage.getItem('Nidin_orderTable_storeS')
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (storeS && !self.isCreatedStore) {
              self.storeSelect.value = storeS
              self.isCreatedStore = true
            } else if (i === 0) {
              if (self.getRoleType === '10' || self.getRoleType === 10) self.storeSelect = obj
              self.getOrderList(1)
            }
          }
        }
      })
    },
    getStoreBriefQ (brandId) {
      console.log('getStoreBriefQ | QueryStringTemp')
      this.storeBriefQ = [{value: 0, label: '==門市=='}]
      var self = this
      var storeS = window.sessionStorage.getItem('Nidin_orderTable_storeS')
      var url = '/brand/' + brandId + '/storeListBrief?status=2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBriefQ.push(obj)
            if (storeS && !self.isCreatedStoreQ) {
              self.store_query.value = storeS
              self.isCreatedStoreQ = true
            } else if (i === 0) {
              self.getOrderList(1)
            }
            if (sList.length === 1) {
              self.store_query.value = sList[0].store_id
            }
          }
        }
      })
    },
    delcode (code, brand, store) {
      var self = this
      var roleType = parseInt(self.getRoleType, 10)
      var url
      if (roleType === 99) {  // platform
        url = '/brand/' + brand + '/srcVendorCode/' + code
      } else if (roleType === 30) { // brand
        url = '/brand/' + brand + '/srcVendorCode/' + code
      } else if (roleType === 10) { // store
        url = '/store/' + store + '/srcVendorCode/' + code
      }
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getOrderList(1)
        }
      })
    },
    postVendorCode () {
      var self = this
      var senddata
      var url
      if (self.brand_query.value) var brandId = self.brand_query.value
      if (self.store_query.value) var storeId = self.store_query.value
      if (self.name_query) var nameQ = self.name_query
      if (self.code_query) var codeQ = self.code_query
      if (self.sourceSelect) var sourceQ = self.sourceSelect

      if (storeId) {
        url = '/store/' + storeId + '/srcVendorCode'
        senddata = {
          name: nameQ,
          code: codeQ,
          url_type: sourceQ
        }
      }
      if (brandId && !storeId) {
        url = '/brand/' + brandId + '/srcVendorCode'
        senddata = {
          name: nameQ,
          code: codeQ,
          url_type: sourceQ
        }
      }
      this.getDataH('post', url, senddata, function (response) {
        if (response.data.status === 200) {
          // self.brand_query = 0
          if (self.roleType !== 10) {
            self.store_query.value = 0
          }
          self.name_query = null
          self.code_query = null
          self.sourceSelect = 999
          self.$notify('成功新增')
          self.getOrderList(1)
        }
      })
    },
    postStoreVendorCode (storeId) {
      this.storeBrief = []
      // var self = this
      var brandId = window.sessionStorage.getItem('Nidin_orderTable_storeS')
      var url = '/brand/' + brandId + '/srcVendorCode'
      this.getDataH('post', url, null, function (response) {
        if (response.data.status === 200) {
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    checkMemberShow (status) {
      if (this.roleType === 30) {
        if (status === 130 || status === 140) return true
        else return false
      } else return true
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY/MM/DD')
    }
  },
  created () {
    /*
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    this.menuTime.start.time = moment(firstDay).format('YYYY-MM-DD')
    */
    this.getBrandBrief()
    this.roleType = parseInt(this.getRoleType, 10)
    if (this.$route.name === 'memberOrderTable') this.shopperId = this.$route.params.user_id
    if (this.$route.name === 'storeInfo') {
      this.brandSelect = this.$route.params.brand_id
      this.count = 10
    }
    var tIndex = window.sessionStorage.getItem('Nidin_orderTable_tIndex')
    var pGroup = window.sessionStorage.getItem('Nidin_orderTable_pGroup')
    var brandS = window.sessionStorage.getItem('Nidin_orderTable_brandS')
    var storeS = window.sessionStorage.getItem('Nidin_orderTable_storeS')
    var typeS = window.sessionStorage.getItem('Nidin_orderTable_typeS')
    var statusS = window.sessionStorage.getItem('Nidin_orderTable_statusS')
    var deTypeS = window.sessionStorage.getItem('Nidin_orderTable_deTypeS')
    var trTypeS = window.sessionStorage.getItem('Nidin_orderTable_trTypeS')
    var searchS = window.sessionStorage.getItem('Nidin_orderTable_searchS')
    // var menuTimeStart = window.sessionStorage.getItem('Nidin_orderTable_menuTime_start')
    // var menuTimeEnd = window.sessionStorage.getItem('Nidin_orderTable_menuTime_end')
    var orderSn = window.sessionStorage.getItem('Nidin_orderTable_orderSn')
    var shopper = window.sessionStorage.getItem('Nidin_orderTable_shopper')
    var subOrderAmount = window.sessionStorage.getItem('Nidin_orderTable_subOrderAmount')
    // queryString
    // var quStringS = window.sessionStorage.getItem('Nidin_orderTable_quStringS')
    if (tIndex && pGroup) {
      // this.tableIndex = parseInt(tIndex, 10)
      // this.pageGroup = parseInt(pGroup, 10)
    }
    if (brandS && !isNaN(brandS)) this.brandSelect.value = parseInt(brandS, 10)
    if (storeS && !isNaN(storeS)) this.storeSelect.value = parseInt(storeS, 10)
    if (typeS && this.$route.name === 'orderTable' && !isNaN(typeS)) this.typeSelect = parseInt(typeS, 10)
    if (statusS && !isNaN(statusS)) this.statusSelect = parseInt(statusS, 10)
    if (deTypeS && !isNaN(deTypeS)) this.deTypeSelect = parseInt(deTypeS, 10)
    if (trTypeS && !isNaN(trTypeS)) this.trTypeSelect = parseInt(trTypeS, 10)
    if (searchS && !isNaN(searchS)) {
      this.searchSelect = parseInt(searchS, 10)
      if (this.searchSelect === 1) {
        // if (menuTimeStart) this.menuTime.start.time = menuTimeStart
        // if (menuTimeEnd) this.menuTime.end.time = menuTimeEnd
      } else if (this.searchSelect === 2) {
        if (orderSn) this.orderSn = orderSn
      } else if (this.searchSelect === 3) {
        if (shopper) this.shopper = shopper
      } else if (this.searchSelect === 4) {
        if (subOrderAmount) this.subOrderAmount = subOrderAmount
      }
    }
  },
  mounted () {
    this.$refs.orderPaginate.tableIndex = this.tableIndex
    this.$refs.orderPaginate.pageGroup = this.pageGroup
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    'brand_query.value' () {
      this.store_query = {
        value: 0,
        label: '== 門市 =='
      }
      if (this.$route.name === 'storeInfo') {
        this.store_query.value = this.$route.params.store_id
        this.getStoreBriefQ(this.brand_query.value)
      } if (this.brand_query.value !== 0 && this.brand_query.value !== '0') {
        this.getStoreBriefQ(this.brand_query.value)
      } else {
        // this.getOrderList(1)
      }
      // window.sessionStorage.setItem('Nidin_orderTable_brandQ', this.brand_query)
    },
    'brandSelect.value' () {
      this.storeSelect = {
        value: 0,
        label: '== 門市 =='
      }
      if (this.$route.name === 'storeInfo') {
        this.storeSelect.value = this.$route.params.store_id
        this.getStoreBrief(this.brandSelect.value)
      } if (this.brandSelect.value !== 0 && this.brandSelect.value !== '0') {
        this.getStoreBrief(this.brandSelect.value)
      } else {
        this.getOrderList(1)
      }
      window.sessionStorage.setItem('Nidin_orderTable_brandS', this.brandSelect.value)
    },
    'storeSelect.value' () {
      this.getOrderList(1)
      window.sessionStorage.setItem('Nidin_orderTable_storeS', this.storeSelect.value)
    },
    typeSelect () {
      this.getOrderList(1)
      window.sessionStorage.setItem('Nidin_orderTable_typeS', this.typeSelect)
    },
    statusSelect () {
      this.getOrderList(1)
      window.sessionStorage.setItem('Nidin_orderTable_statusS', this.statusSelect)
    },
    deTypeSelect () {
      this.getOrderList(1)
      window.sessionStorage.setItem('Nidin_orderTable_deTypeS', this.deTypeSelect)
    },
    trTypeSelect () {
      this.getOrderList(1)
      window.sessionStorage.setItem('Nidin_orderTable_trTypeS', this.trTypeSelect)
    }
  }
}
</script>
<style lang="sass">
.shipping-state-label
  position: absolute
  width: max-content
  padding: 5px
  border-radius: 6px
  z-index: 30
  font-size: 12px
  font-weight: 600
  top: -30px
  left: -18px
.text-del
  text-decoration: line-through
.bg-pre-order
  background: #FBF4E6 !important
.active.btn-all, .active.btn-basic, .active.btn-gb
  opacity: 0.4
.p-10
 padding: 10px !important
.time-box
  max-width: 236px
  #start-box, #end-box
    width: auto
  #start-box input
    border-radius: 3px 0px 0px 0px !important
  #end-box input
    border-radius: 0px 0px 0px 3px !important
@media screen and (max-width: 768px)
  .time-box
    max-width: calc( 100vw - 20px)
@media screen and (max-width: 768px)
 .time-box .cov-vue-date .cov-datepicker
    width: calc(100vw - 90px)
</style>



// WEBPACK FOOTER //
// QueryStringTemp.vue?192e9adc